import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import { PAGE } from "constants/configConstants";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import { unitTypes } from "../../../utils";
import styles from "./RoomTypeTabSection.module.scss";
import getCurrentFilterName from "./utils/getCurrentFilterName";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { AppState } from "@Store/index";
import useStickyScrolling from "hooks/useStickyScrolling";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";
import useAppPadding from "hooks/useAppPadding";

const TabSection = ({
  tabdata = {},
  setActiveTab,
  activeTab,
  appliedFilters,
  isDesktop = false,
  filterCount,
}: any) => {
  const [addSticky, setAddSticky] = useState(false);
  const { showAppBanner } = useSelector(({ appData }: AppState) => ({
    showAppBanner: appData.showAppBanner,
  }));
  const tabWrapperRef = useRef(null);
  const isRoomTypeV2 = true;
  const appPadding = useAppPadding();

  useStickyScrolling({
    elRef: tabWrapperRef,
    toggleHeight: 54,
    defaultTop: isDesktop ? 108 : 102 + appPadding,
    hookCondition: [showAppBanner && !isDesktop && addSticky, appPadding],
    offset: 50,
    scrollCondition: !isDesktop,
  });

  const handleOnScroll = () => {
    const element = document.getElementById("room_type");
    const currOffset = window.pageYOffset;
    if (element?.offsetTop && currOffset - 125 + 48 > element?.offsetTop) {
      setAddSticky(true);
    } else {
      setAddSticky(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleOnScroll);
    return () => {
      window.removeEventListener("scroll", handleOnScroll);
    };
  }, []);
  const { t } = useTranslationHook();

  const handleTabClick = (tab: string) => {
    setActiveTab(tab);
    gtagEventEmitter({
      action: "Room_type_tab_clicked",
      category: PAGE.INVENTORY,
      label: "success",
      tab_clicked: tab,
    });
    const element = document.getElementById("room_type");
    if (!element) return;
    const headerOffset = 54 + 48 - 125; // padding plus navbar height
    const elementPosition = element?.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };
  return (
    <div
      className={formatClassNames(
        isRoomTypeV2 ? styles.parentContainerV2 : styles.parentContainer,
        addSticky && styles.sticky,
        isDesktop && styles.desktop,
      )}
      ref={tabWrapperRef}
    >
      <div className={formatClassNames(styles.container, isRoomTypeV2 && styles.containerV2)}>
        {Object.keys(tabdata)?.map((tab: string) => (
          <div
            data-testid="property-room-type-tabs"
            className={formatClassNames(
              styles.tab,
              tab === activeTab && styles.active,
              isDesktop && styles.desktop,
              isRoomTypeV2 && styles.tabV2,
            )}
            role="none"
            onClick={() => handleTabClick(tab)}
            key={tab}
          >
            {unitTypes[tab]} ({tabdata[tab]?.length})
          </div>
        ))}
      </div>
      {filterCount > 0 && (
        <div
          className={formatClassNames(styles.subContainer, isRoomTypeV2 && styles.subContainerV2)}
        >
          <div data-testid="property-search-for-filter" className={styles.textContainer}>
            {t(
              "propertypage.roomtypesectiondynamic.propertyfilterssection.tabsection.sinceyousearchedfor",
            )}
            &nbsp;
            <span data-testid="property-applied-filter">
              {Object.keys(appliedFilters)
                ?.map((obj) => {
                  const filterVal = getCurrentFilterName(obj, appliedFilters);
                  if (filterVal === "46 weeks") return "45+ weeks";
                  return filterVal;
                })
                ?.filter((val) => val !== "")
                ?.join(" + ")}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default wrapperHOC(TabSection, {
  componentName: "TabSection-PropertyFiltersSection-RoomTypeSection-PropertyPage",
  showForChina: true,
});
